module.exports = __webpack_public_path__ + "img/04-round-convex-1.0f735b3f.svg";